import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyPhotoTrioLayout = loadable(() => import(/* webpackChunkName: "content/guest/header/photoTrio" */ './PhotoTrio'), 'PhotoTrioLayout');
